export default __webpack_public_path__ + "static/media/m_use_action_xw.c6d85881.png";